// extracted by mini-css-extract-plugin
export default {"title":"PropDetailList_title__G+IDc","detail":"PropDetailList_detail__xtks5","detailName":"PropDetailList_detailName__T4v2f","detailInfo":"PropDetailList_detailInfo__k0o+i"};